import React from 'react'

export default function WinterDataSummit() {
  return (
    <div>
       <div class="service_area pb-70">
       <div class="section_title text_center mb-70 ">
              
              <div class="section_main_title">
                <h2> Past<span> Events</span></h2>
              </div>
              <div class="em_bar">
                <div class="em_bar_bg"></div>
              </div>
        </div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-6 col-sm-12 event d-flex justify-content-center mb-3 mb-md-0">
            <div class="service_style_two mb-4">
              <div class="service_style_two_number mr-60 w-30">
              <img src='assets/images/winter-data-summit.png' className="img-fluid" alt="Winter Data Summit"/>
              </div>
           
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="service_style_two mb-4">
           
              <div class="service_style_two_content">
                <div class="service_style_two_title pb-3 mr-70">
                  <h4>New York Winter Data Summit 2025. </h4>
                </div>
                <div class="service_style_two_text">
                  <p className='text-left ml-75'>
                  Date - 4th December 2025  <br/> Venue - Convene, Brookfield Place, 225 Liberty St, New York, NY 10281
                  </p>
                  <div class="button three past-event mr-300">
                <a href="/winter-data-summit-event">Know More</a>
              </div>
                </div>
              </div>
            </div>
          </div>
       
         
      
         
        </div>
      </div>
    </div>
    </div>
  )
}
